import React from 'react';
import './JobOnHoldModal.css';

const JobOnHoldModal = ({ isOpen, onClose, isMobile = false }) => {
  if (!isOpen) return null;

  return (
    <div className="job-on-hold-modal-overlay">
      <div className="job-on-hold-modal">
        {/* Header */}
        <div className="job-on-hold-modal-header">
          <h2>Job Status</h2>
          <div className="job-on-hold-modal-close-container">
            {!isMobile && (
              <span className="job-on-hold-modal-esc-key">esc</span>
            )}
            <button
              onClick={onClose}
              className="job-on-hold-modal-close-button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="job-on-hold-modal-content">
          <div className="job-on-hold-modal-icon-container">
            <div className="job-on-hold-modal-icon">
              <span>!</span>
            </div>
          </div>

          <h2 className="job-on-hold-modal-title">
            This job is currently on hold
          </h2>

          <p className="job-on-hold-modal-message">
            We appreciate your interest in this position. The job opening is temporarily on hold.
            We'll contact you as soon as it becomes available again.
          </p>
        </div>

        {/* Footer */}
        <div className="job-on-hold-modal-footer">
          <button 
            className="job-on-hold-modal-button"
            onClick={onClose}
          >
            I understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobOnHoldModal;
